import { render, staticRenderFns } from "./BannerUploader.vue?vue&type=template&id=3e65f773&scoped=true&"
import script from "./BannerUploader.vue?vue&type=script&lang=js&"
export * from "./BannerUploader.vue?vue&type=script&lang=js&"
import style0 from "./BannerUploader.vue?vue&type=style&index=0&id=3e65f773&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e65f773",
  null
  
)

export default component.exports